// Libs
import * as yup from 'yup';
// Others
import { IPermissionRole } from '~/utils/interface/role';

export const schema = (): yup.ObjectSchema<IPermissionRole> => {
  return yup.object().shape({});
};

export const defaultValuesPermissionForm: IPermissionRole = {};
